module.exports = "/_next/static/files/79bf579e053d4aa8ec11b93b8c3f46b9.jpg";